const TextHeading = ({ heading }) => {
  return (
    <h1 className="bg-Apple py-4 font-bold border-Apple border-solid rounded-md rounded-b-none p-2 text-2xl text-white text-center" style={{ textShadow: "0px 1px 2px #26465f" }}>
      {heading}
    </h1>
  );
};

export default TextHeading;
